import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { Space } from '@sravni/react-design-system';
import { FormControl as FormControlDS } from '@sravni/react-design-system/lib/FormControl';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useIsPhone, useStyles } from '@sravni/react-utils';

import { FormControl } from '../../../../UI/FormControl';
import { TUserChangeHandler } from '../../../../UI/FormControl/types';
import { REVIEW_FIELDS } from '../../../constants/common';
import { makeLabelRequired } from '../../../utils/makeLabelRequired';
import { Step } from '../Step/Step';

import { RATING_TEXTS } from './constants';
import styles from './rating-step.module.scss';

type TProps = {
  isReadOnly: boolean;
  handleUserChange?: TUserChangeHandler;
};

const fieldName = REVIEW_FIELDS.RATING;

export const RatingStep: React.FC<TProps> = ({ isReadOnly, handleUserChange }) => {
  const cx = useStyles(styles);
  const isPhone = useIsPhone();

  const {
    control,
    getFieldState,
    formState: { errors },
  } = useFormContext();
  const { invalid } = getFieldState(fieldName);
  const ratingValue = useWatch({ name: fieldName, control });
  const error = errors?.[fieldName];

  return (
    <Step title={'Оцените свой опыт по шкале от 1 до 5'}>
      <FormControlDS invalid={invalid}>
        <Space
          className={cx('wrapper', { wrapperFilled: ratingValue > 0, wrapperInvalid: invalid })}
          direction={isPhone ? 'vertical' : 'horizontal'}
          size={12}
          align={'center'}
        >
          <FormControl
            controlType="rates"
            name={REVIEW_FIELDS.RATING}
            control={control}
            disabled={isReadOnly}
            size={36}
            className={cx('ratesWrapper')}
            fieldClassName={cx('rates')}
            handleUserChange={handleUserChange}
          />
          <Text size={14} className={cx('h-color-D60', 'text', 'h-text-center')}>
            {RATING_TEXTS[ratingValue] ?? makeLabelRequired('Нажмите, чтобы оценить')}
          </Text>
        </Space>
        {error && <FormControlDS.HelperText>{error.message}</FormControlDS.HelperText>}
      </FormControlDS>
    </Step>
  );
};
